import { render, staticRenderFns } from "./RightHeaderComponent.vue?vue&type=template&id=08d1d158&"
import script from "./RightHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./RightHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports